module.exports = __webpack_public_path__ + "img/607.a70fa847.jpg";